import Dexie, { EntityTable } from "dexie";
import { Book, Chapter, Verse, Version } from "./types";

export const bibleDB = new Dexie('BibleDatabase') as Dexie & {
  versions: EntityTable<Version, 'id'>,
  books: EntityTable<Book, 'id'>,
  chapters: EntityTable<Chapter, 'index'>,
  verses: EntityTable<Verse, 'index'>
};

bibleDB.version(1).stores({
  versions: 'id,language',
  books: '[version_id+id],index',
  chapters: '[version_id+book_id+index]',
  verses: '[version_id+book_index+chapter_index+index]'
});
